import React, { useState, useContext } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";

import { Context } from "../../../_context/Store";
import { homeTurnOffPopupRequest } from "../../../_redux/_actions";
import SherbortLogo from "../../../styles/img/sherbot-logo.png";
import AuthInfoIcon from "../../../styles/img/svg/AuthInfoIcon";
import { UiButtonPrimary } from "../form/UiButton";

export const UiModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                className={
                    props.className
                        ? props.className
                        : "sb-main-modal sb-sign-up-modal"
                }
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiShopModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-order"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiWalletModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-wallet"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.title}
                        <h5>{props.points}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiSpinWinCarouselModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-spin-win"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiLargeModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_large_modal.show}
                onHide={handleClose}
                className="sb-main-modal sb-large-modal "
                backdrop={state.ui_large_modal?.backdrop}
                centered={state.ui_large_modal?.centered}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_large_modal.title}</Modal.Title>
                </Modal.Header>
                {state.ui_large_modal?.subTitle && (
                    <div className="sb-large-modal__sub-title">
                        {state.ui_large_modal.subTitle}
                    </div>
                )}
                <Modal.Body>{state.ui_large_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiChatBotModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "CHAT_BOX_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_chat_box.show}
                onHide={handleClose}
                backdrop="static"
                centered
                className="sb-main-modal sb-chat-box-modal "
            >
                <Modal.Header closeButton>
                    <img src={SherbortLogo} />
                </Modal.Header>

                <Modal.Body>{state.ui_chat_box.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiFooterContentModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "FOOTER_CONTENT_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_footer_modal.show}
                onHide={handleClose}
                centered
                className="sb-footer-support-modal "
            >
                <Modal.Header closeButton></Modal.Header>

                <Modal.Body>{state.ui_footer_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiPdfModal = (props) => {
    return (
        <>
            <Modal
                show={props.show}
                onHide={props.modalShowHide}
                backdrop={props.backdrop}
                className="sb-modal-pdf-view"
                id={props.id}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiHomePerformanceModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        localStorage.setItem("perfomance-view", "true");
        dispatch({
            type: "HOME_PERFORMANCE_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_home_performance_modal.show}
                onHide={handleClose}
                backdrop="static"
                centered
                className="sb-performance-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {state.ui_home_performance_modal.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {state.ui_home_performance_modal.children}
                </Modal.Body>
            </Modal>
        </>
    );
};

export const UiVotingModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "VOTING_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_voting_modal.show}
                onHide={handleClose}
                backdrop="static"
                className="sb-voting-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_voting_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{state.ui_voting_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiMessageModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "MESSAGE_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_message_modal.show}
                onHide={handleClose}
                backdrop="static"
                className="sb-message-modal"
            >
                <Modal.Header closeButton>
                    
                </Modal.Header>
                <AuthInfoIcon />
                <Modal.Body>{state.ui_message_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};
export const UiInfoModal = (props) => {
    const [state, dispatch] = useContext(Context);
    const actionDispatch = useDispatch();

    const handleClose = () => {
        sessionStorage.setItem("stopApiCall", "true");
        actionDispatch(homeTurnOffPopupRequest({}));
        dispatch({
            type: "INFO_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_info_modal.show}
                onHide={handleClose}
                centered
                backdrop="static"
                className="sb-info-modal"
            >
                <Modal.Header closeButton>
                    
                </Modal.Header>
                
                <Modal.Body>{state.ui_info_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};
export const UiProfileImgModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        localStorage.setItem("profile-modal", "true");
        dispatch({
            type: "PROFILE_IMG_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_profile_modal.show}
                onHide={handleClose}
                centered
                className="sb-main-modal sb-profile-img-modal "
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_profile_modal.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>{state.ui_profile_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiSurveyModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "SURVEY_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_survey_modal.show}
                onHide={handleClose}
                centered
                backdrop="static"
                className="sb-main-modal sb-profile-img-modal sb-survey-modal "
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_survey_modal.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>{state.ui_survey_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiRedirectModal = (props) => {
    const [state, dispatch] = useContext(Context);
    const [countdown, setCountdown] = React.useState(5);

    React.useEffect(() => {
        if (state.ui_redirect_modal.show && countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
            return () => clearTimeout(timer);
        } else if (state.ui_redirect_modal.show && countdown === 0) {
            window.location.href = state.ui_redirect_modal.redirectUrl;
        }
    }, [
        state.ui_redirect_modal.show,
        countdown,
        state.ui_redirect_modal.redirectUrl,
    ]);

    React.useEffect(() => {
        if (state.ui_redirect_modal.show) {
            setCountdown(5);
        }
    }, [state.ui_redirect_modal.show]);

    return (
        <>
            <Modal
                show={state.ui_redirect_modal.show}
                backdrop="static"
                centered
                keyboard={false}
                className="sb-main-modal sb-redirect-modal"
            >
                <Modal.Header>
                    <Modal.Title>{state.ui_redirect_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="sb-redirect-modal-content">
                        <p>{state.ui_redirect_modal.message}</p>
                        <p className="sb-redirect-countdown">
                            Redirecting in <strong>{countdown}</strong>{" "}
                            seconds...
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


export const UiMultiPdfViewerModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "MULTI_PDF_VIEWER_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_multi_pdf_viewer_modal.show}
                onHide={handleClose}
                className="sb-multi-pdf-viewer-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{state.ui_multi_pdf_viewer_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{state.ui_multi_pdf_viewer_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiDataInfoModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        dispatch({
            type: "DATA_INFO_MODAL",
            payload: { show: false },
        });
    };

    return (
        <>
            <Modal
                show={state.ui_data_info_modal.show}
                onHide={handleClose}
                backdrop="static"
                centered
                className="sb-data-info-modal"
            >
                <Modal.Header closeButton>
                    
                </Modal.Header>
                <AuthInfoIcon />
                <Modal.Body>{state.ui_data_info_modal.children}</Modal.Body>
            </Modal>
        </>
    );
};

export const UiConfirmationModal = (props) => {
    const [state, dispatch] = useContext(Context);

    const handleClose = () => {
        state.ui_confirmation_modal?.onCancel?.();
        dispatch({
            type: "UI_CONFIRMATION_MODAL",
            payload: {
                show: false,
                message: "",
                onConfirm: () => {},
                onCancel: () => {},
            },
        });
    };

    const handleConfirm = () => {
        const onConfirm = state.ui_confirmation_modal?.onConfirm;
        dispatch({
            type: "UI_CONFIRMATION_MODAL",
            payload: {
                show: false,
                message: "",
                onConfirm: () => {},
                onCancel: () => {},
            },
        });
        onConfirm?.();
    };

    return (
        <>
            <Modal
                className="sb-confirmation-modal"
                show={state.ui_confirmation_modal.show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton> 
                    <Modal.Title>{state.ui_confirmation_modal.title}</Modal.Title>
                    </Modal.Header>
                <Modal.Body>
                    {state.ui_confirmation_modal.message ||
                        "Are you sure you want to delete this team member?"}
                </Modal.Body>

                <Modal.Footer>
                    <UiButtonPrimary
                        btnName="Cancel"
                        variant="outline-secondary"
                        onClick={handleClose}
                    />
                    <UiButtonPrimary
                        btnName="Delete"
                        variant="danger"
                        onClick={handleConfirm}
                    />
                </Modal.Footer>
                    
                
            </Modal>
        </>
    );
};